import AssetDetails from "../components/AssetDetails";
import { useParams } from "react-router-dom";

const AssetDetailsPage = () => {
  const params = useParams();
    
  return (
    <section className="">
      <AssetDetails />
    </section>
  );
};

export default AssetDetailsPage;